import {useRankedBrandTraits} from "./brand-traits";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {httpsCallable} from "firebase/functions";
import {functions} from "hooks/firebase";
import {RecommendedColors2Request, RecommendedColors2Response} from "data/models/shared/recommended-colors2";

export function useRecommendedColors2():
    [RecommendedColors2Response | null, boolean, Error | null] {
  const [rankedBrandTraits, rankedTraitsLoading, rankedTraitsError] = useRankedBrandTraits();
  const [error, setError] = useState<Error | null>(null);

  const [recommendedColors2, setRecommendedColors2] = useState<RecommendedColors2Response | null>(null);


  useEffect(() => {
    const anError = (
        rankedTraitsError
    );
    if (!isNullOrUndefined(anError)) {
      setError(anError);
      return;
    }
    if (
        rankedTraitsLoading
    ) {
      return;
    }
    if (isNullOrUndefined(rankedBrandTraits)) {
      return;
    }

    const recommendedColors2Request = {
      rankedBrandTraits: rankedBrandTraits?.slice(0, 2).map(trait => trait.traitKey),
    };

    const recommendedColors2Function = httpsCallable<RecommendedColors2Request, RecommendedColors2Response>(functions, 'recommendedColors2');

    recommendedColors2Function(recommendedColors2Request).then(result => {
      setRecommendedColors2(result.data);
      setError(null);
    }).catch((error) => {
      setError(error as Error);
    });

  }, [
    // masterLoading,
    rankedBrandTraits, rankedTraitsLoading, rankedTraitsError,
  ]);

  return [recommendedColors2, rankedTraitsLoading, error];
}
